import api from './api';

class InvoiceService {
	async create(invoiceForm) {
		return api
			.post('/invoices', invoiceForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log('fail when trying create a new invoice.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async syncronizeStatusWithIUGU(order) {
		return api
			.post('/invoices/syncronize/status/with/iugu', order)
			.then((response) => response.data)
			.catch((error) => {
				console.log('fail when trying syncronize');
				throw error.response?.data?.error;
			});
	}
}

const invoiceService = new InvoiceService();
export default invoiceService;
